import { Form as AntForm } from 'antd';
import { FormProps } from 'antd/es/form';
import classnames from 'classnames';

import classes from './index.module.scss';
import type { FC } from 'react';

interface IInlineFormProps<V = any> extends FormProps<V> {
  className?: string;
  children?: React.ReactNode;
}

type CompoundedComponent = FC<IInlineFormProps> & {
  useForm: typeof AntForm.useForm;
  useWatch: typeof AntForm.useWatch;
  Item: typeof AntForm.Item;
  List: typeof AntForm.List;
  ErrorList: typeof AntForm.ErrorList;
};

const InlineForm = (props: IInlineFormProps) => {
  const { className, ...rest } = props;

  return <AntForm className={classnames('InlineForm', classes.wrap, className)} {...rest} />;
};

(InlineForm as CompoundedComponent).useForm = AntForm.useForm;
(InlineForm as CompoundedComponent).useWatch = AntForm.useWatch;
(InlineForm as CompoundedComponent).Item = AntForm.Item;
(InlineForm as CompoundedComponent).List = AntForm.List;
(InlineForm as CompoundedComponent).ErrorList = AntForm.ErrorList;
InlineForm.displayName = 'InlineForm';
export default InlineForm as CompoundedComponent;
export const Form = AntForm;
export const FormItem = Form.Item;
